import { Routes } from '@angular/router';
import { authGuard, oauthRoutes, tenantGuard, tenantRoutes } from '@cmi/addin-core';
import { ContentProviders } from './home/content-providers/content-providers';
import { ParameterSettings } from './home/content-providers/parameter-settings/parameter-settings';
import { ProviderProperties } from './home/content-providers/provider-properties/provider-properties';
import { Home } from './home/home';
import { ModelNavigation } from './home/model-navigation/model-navigation';
import { Reports } from './home/reports/reports';
import { CopyContents } from './settings/copy-contents/copy-contents';
import { DocumentProperties } from './settings/document-properties/document-properties';
import { DocumentPropertyEdit } from './settings/document-properties/document-property-edit/document-property-edit';
import { LanguageSettings } from './settings/lang/lang';
import { Settings } from './settings/settings';
import { SettingsLayout } from './settings/settings-layout';
import { UsedControls } from './settings/used-controls/used-controls';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/apps',
    pathMatch: 'full'
  },
  {
    path: 'model-navigation',
    canActivate: [tenantGuard, authGuard],
    component: ModelNavigation
  },
  {
    path: 'reports',
    canActivate: [tenantGuard, authGuard],
    component: Reports
  },
  {
    path: 'apps',
    canActivate: [tenantGuard, authGuard],
    children: [
      {
        path: '',
        component: Home
      },
      {
        path: ':tag',
        component: ContentProviders
      },
      {
        path: ':tag/providers/:key',
        component: ProviderProperties
      },
      {
        path: ':tag/providers/:key/parameters/:parameterName',
        component: ParameterSettings
      }
    ]
  },
  {
    path: 'settings',
    component: SettingsLayout,
    data: { hideTenantBar: true },
    children: [
      {
        path: '',
        component: Settings
      },
      {
        path: 'lang',
        component: LanguageSettings
      },
      {
        path: 'copy-contents',
        component: CopyContents
      },
      {
        path: 'used-controls',
        component: UsedControls
      },
      {
        path: 'document-properties',
        component: DocumentProperties
      },
      {
        path: 'document-properties/:groupName',
        component: DocumentPropertyEdit
      }
    ]
  },
  ...tenantRoutes,
  ...oauthRoutes
];
